import ENV from "../env";

const createStripeAccountLink = async (stripeId, options = {}) => {
  const response = await fetch(`${ENV.firebaseApiUrl}/stripe/create-account-link`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      stripeId,
      ...options,
    }),
  });

  const resData = await response.json();

  if (!response.ok) {
    throw new Error(
      resData?.error?.raw?.message ||
        resData?.error?.message ||
        resData?.error ||
        resData?.message ||
        "Erreur inconnue lors de la création du lien Stripe",
    );
  }

  return resData;
};

export default createStripeAccountLink;
